/** @jsx jsx */
import React, { memo } from 'react';
import { css, jsx } from '@compiled/react';
import AsyncIcon from '@atlassian/jira-common-components-async-icon/src/view.tsx';

export type Props = {
	iconUrl: string;
	name: string;
};

export const TypeCell = memo<Props>(({ iconUrl, name }: Props) => (
	<div css={typeCellStyles}>
		<AsyncIcon url={iconUrl} alt={name} />
	</div>
));

const typeCellStyles = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
});
